"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.whenUserLogout = exports.apiVerifyAuthRequestStatus = exports.apiGetAuthRequest = exports.apiValidateOTPRequest = exports.apiTACValidateRequest = exports.apiUserVerifyRequest = exports.apiValidateOTPWrapper = exports.apiMfaSendSoftTokenWrapper = exports.apiTacAuthorizationStatusRetrieveWrapper = exports.apiPaymentHardTokenSubmit = exports.apiAccesHardWareSubmitWrapper = exports.apiMfaSendOtpWrapper = exports.apiTACValidateWrapper = exports.apiUserVerifyRequestWrapper = void 0;
//import { userVerifyRequest, mfaSendOtp, tacValidateRequest, tacAuthorizationStatusRetrieve } from '@/data-manager/ms-cust-sec/transactionSigningAPI'
const transactionSigningAPI_1 = require("@/data-manager/ms-cust-sec/transactionSigningAPI");
const effects_1 = require("redux-saga/effects");
const constants_1 = require("@/common/utils/constants");
const constants_2 = require("@/features/login2fa/constants");
const tfa_1 = require("@/data-manager/ms-cust-sec/tfa");
const transactionSigningApi_1 = require("@/data-manager/ms-ui-payment/transactionSigningApi");
const transactionSigningApi_2 = require("@/data-manager/ms-ui-token-management/transactionSigningApi");
const constants_3 = require("@/features/transaction-signing/constants");
function* apiUserVerifyRequestWrapper(request, headers) {
    try {
        const response = yield (0, effects_1.call)(exports.apiUserVerifyRequest, request, headers);
        console.log('responseWrapper:');
        console.log(response);
        if (Object.keys(response).length > 0) {
            return {
                isError: false,
                data: response
            };
        }
        return {
            isError: true,
            systemMessages: constants_1.SYSTEM_MESSAGES_COMMON.API_ERROR
        };
    }
    catch (error) {
        console.error('apiUserVerifyRequestWrapper, error: ', error);
        return {
            isError: true,
            systemMessages: constants_1.SYSTEM_MESSAGES_COMMON.API_ERROR
        };
    }
}
exports.apiUserVerifyRequestWrapper = apiUserVerifyRequestWrapper;
function* apiTACValidateWrapper(request, headers) {
    try {
        // const params = {
        // } as IMfaSendOtpRequest;
        const response = yield (0, effects_1.call)(exports.apiTACValidateRequest, request, headers);
        return {
            isError: false,
            data: response
        };
    }
    catch (error) {
        console.error('apiTACValidateWrapper, error: ', error);
        return {
            isError: true,
            systemMessages: constants_1.SYSTEM_MESSAGES_COMMON.API_ERROR
        };
    }
    // return {
    //     // isError: true,
    //     // systemMessages: SYSTEM_MESSAGES_COMMON.UNKNOWN_ERROR,
    // } as IMfaSendOtpResponseWrapper;
}
exports.apiTACValidateWrapper = apiTACValidateWrapper;
function* apiMfaSendOtpWrapper(request, headers) {
    try {
        // const params = {
        // } as IMfaSendOtpRequest;
        const response = yield (0, effects_1.call)(apiMfaSendOtp, request, headers);
        return {
            isError: false,
            data: response
        };
    }
    catch (error) {
        console.error('apiMfaSendOtpWrapper, error: ', error);
        return {
            isError: true,
            systemMessages: constants_1.SYSTEM_MESSAGES_COMMON.API_ERROR
        };
    }
    // return {
    //     // isError: true,
    //     // systemMessages: SYSTEM_MESSAGES_COMMON.UNKNOWN_ERROR,
    // } as IMfaSendOtpResponseWrapper;
}
exports.apiMfaSendOtpWrapper = apiMfaSendOtpWrapper;
function* apiAccesHardWareSubmitWrapper(request, headers) {
    try {
        const response = yield (0, effects_1.call)(apiAccesHardWareSubmit, request, headers);
        console.log('apiAccesHardWareSubmitWrapper.response', response);
        if (response.body &&
            (response.body === constants_2.ACCESS_ELEVATION_VALIDATE_STRATUS.ELEVATION_SUCCESS || response.body === constants_2.ACCESS_ELEVATION_VALIDATE_STRATUS.ELEVATION_FAILED)) {
            return {
                isError: false,
                data: response
            };
        }
        return {
            isError: true,
            systemMessages: constants_1.SYSTEM_MESSAGES_COMMON.API_ERROR
        };
    }
    catch (error) {
        console.error('apiAccesHardWareSubmitWrapper, error: ', error);
        return {
            isError: true,
            systemMessages: constants_1.SYSTEM_MESSAGES_COMMON.API_ERROR
        };
    }
}
exports.apiAccesHardWareSubmitWrapper = apiAccesHardWareSubmitWrapper;
function* apiPaymentHardTokenSubmit(request, headers, isFinancial) {
    try {
        const res = yield (0, effects_1.call)(transactionSigningApi_1.hardTokenValidate, request, headers, isFinancial);
        if (res.result === 'SUCCESS') {
            return {
                isError: false,
                status: 'SUCCESS',
                data: res
            };
        }
        else if (res.result === 'EXCEED_2FA_MAX_ATTEMPT') {
            return {
                isError: true,
                status: 'EXCEED_2FA_MAX_ATTEMPT',
                systemMessages: constants_3.SYSTEM_MESSAGE_HARD_TOKEN.EXCEED_2FA_MAX_ATTEMPT,
                data: res
            };
        }
        else if (res.result === 'USER_NO_ACTIVE_HARD_TOKEN') {
            return {
                isError: true,
                status: 'USER_NO_ACTIVE_HARD_TOKEN',
                systemMessages: constants_3.SYSTEM_MESSAGE_HARD_TOKEN.USER_NO_ACTIVE_HARD_TOKEN,
                data: res
            };
        }
        else {
            return {
                isError: true,
                status: 'FAILED',
                systemMessages: constants_3.SYSTEM_MESSAGE_HARD_TOKEN.INVALID_RESPONSE_CODE
            };
        }
    }
    catch (error) {
        console.error('apiPaymentHardTokenSubmit, error: ', error);
        const tempError = error.toString();
        if (tempError === 'Error: 401-unassign') {
            return {
                isError: true,
                status: 'USER_NO_ACTIVE_HARD_TOKEN',
                systemMessages: constants_3.SYSTEM_MESSAGE_HARD_TOKEN.USER_NO_ACTIVE_HARD_TOKEN
            };
        }
        else {
            return {
                isError: true,
                status: 'FAILED',
                systemMessages: constants_3.SYSTEM_MESSAGE_HARD_TOKEN.HOST_ERROR
            };
        }
    }
}
exports.apiPaymentHardTokenSubmit = apiPaymentHardTokenSubmit;
const apiAccesHardWareSubmit = (request, headers) => __awaiter(void 0, void 0, void 0, function* () {
    const result = yield (0, tfa_1.accesHardWareSubmit)(request, headers);
    console.log('apiAccesHardWareSubmit, result:');
    console.log(result);
    return result;
});
function* apiTacAuthorizationStatusRetrieveWrapper(request, headers) {
    try {
        const params = {
            authorizationId: request.authorizationId,
            transactionId: request.transactionId,
            refCode: request.refCode,
            authorizationTypeCode: request.authorizationTypeCode
        };
        const response = yield (0, effects_1.call)(apiTacAuthorizationStatusRetrieve, params, headers);
        console.log('apiTacAuthorizationStatusRetrieveWrapper,response', response);
        if (response.status === 'SUCCESS' || response.status === 'FAILED' || response.status === 'PENDING') {
            return {
                isError: false,
                data: response
            };
        }
        return {
            isError: true,
            systemMessages: constants_1.SYSTEM_MESSAGES_COMMON.UNKNOWN_ERROR
        };
    }
    catch (error) {
        console.error('apiTacAuthorizationStatusRetrieveWrapper, error: ', error);
        if (error.toString() === 'Error: 401-unassign') {
            return {
                isError: false,
                data: { status: 'USER_NO_ACTIVE_SOFT_TOKEN' }
            };
        }
        return {
            isError: true,
            systemMessages: constants_1.SYSTEM_MESSAGES_COMMON.API_ERROR
        };
    }
    // return {
    //     isError: true,
    //     systemMessages: SYSTEM_MESSAGES_COMMON.UNKNOWN_ERROR,
    // } as ITac_AuthorizationStatus_RetrieveResponseWrapper;
}
exports.apiTacAuthorizationStatusRetrieveWrapper = apiTacAuthorizationStatusRetrieveWrapper;
function* apiMfaSendSoftTokenWrapper(request, headers) {
    try {
        const response = yield (0, effects_1.call)(transactionSigningApi_1.softTokenRequest, request, headers);
        console.log('apiMfaSendSoftTokenWrapper response', response);
        return {
            isError: false,
            data: response
        };
    }
    catch (error) {
        console.error('apiMfaSendSoftTokenWrapper, error: ', error);
        return {
            isError: true,
            systemMessages: constants_1.SYSTEM_MESSAGES_COMMON.API_ERROR
        };
    }
}
exports.apiMfaSendSoftTokenWrapper = apiMfaSendSoftTokenWrapper;
function* apiValidateOTPWrapper(request, headers) {
    try {
        const response = yield (0, effects_1.call)(exports.apiValidateOTPRequest, request, headers);
        return {
            isError: false,
            data: response
        };
    }
    catch (error) {
        console.error('apiValidateOTPWrapper, error: ', error);
        return {
            isError: true,
            systemMessages: constants_1.SYSTEM_MESSAGES_COMMON.API_ERROR
        };
    }
}
exports.apiValidateOTPWrapper = apiValidateOTPWrapper;
/// /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/// /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/// /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const apiUserVerifyRequest = (request, headers) => __awaiter(void 0, void 0, void 0, function* () {
    const result = yield (0, transactionSigningAPI_1.userVerifyRequest)(request, headers);
    console.log('apiUserVerifyRequest, result:');
    console.log(result);
    return result;
});
exports.apiUserVerifyRequest = apiUserVerifyRequest;
const apiTACValidateRequest = (request, headers) => __awaiter(void 0, void 0, void 0, function* () {
    const result = yield (0, transactionSigningAPI_1.tacValidateRequest)(request, headers);
    console.log('apiTACValidateRequest, result:');
    console.log(result);
    return result;
});
exports.apiTACValidateRequest = apiTACValidateRequest;
const apiMfaSendOtp = (request, headers) => __awaiter(void 0, void 0, void 0, function* () {
    const result = yield (0, transactionSigningAPI_1.mfaSendOtp)(request, headers);
    console.log('apiMfaSendOtp, result:');
    console.log(result);
    return result;
});
const apiTacAuthorizationStatusRetrieve = (request, headers) => __awaiter(void 0, void 0, void 0, function* () {
    console.log('apiTacAuthorizationStatusRetrieve_request', request);
    const result = yield (0, transactionSigningApi_1.tacAuthorizationStatusRequest)(request, headers);
    console.log('apiTacAuthorizationStatusRetrieve, result:', result);
    return result;
});
const apiValidateOTPRequest = (request, headers) => __awaiter(void 0, void 0, void 0, function* () {
    const result = yield (0, transactionSigningApi_1.tacValidateOTPRequest)(request, headers);
    console.log('apiTACValidateRequest, result:');
    console.log(result);
    return result;
});
exports.apiValidateOTPRequest = apiValidateOTPRequest;
const apiGetAuthRequest = (authId, headers) => __awaiter(void 0, void 0, void 0, function* () {
    return (0, transactionSigningApi_2.getTacAuthRequestDetail)(authId, headers);
});
exports.apiGetAuthRequest = apiGetAuthRequest;
const apiVerifyAuthRequestStatus = (authId, headers) => __awaiter(void 0, void 0, void 0, function* () {
    return (0, transactionSigningApi_2.verifyAuthRequestStatus)(authId, headers);
});
exports.apiVerifyAuthRequestStatus = apiVerifyAuthRequestStatus;
// export function whenTokenExpired() {
// 	console.log('whenTokenExpired')
// 	console.log('window: ', window)
// 	//if ((window as any).__POWERED_BY_QIANKUN__) {
// 	console.log('whenTokenExpired set routeType')
// 	const action = {
// 		routeType: RouteTypes.REVOKE_USER
// 	}
// 	window.parent.postMessage(action, window.location.origin)
// 	//}
// }
function whenUserLogout(logoutDetail) {
    return __awaiter(this, void 0, void 0, function* () {
        const action = {
            routeType: constants_3.RouteTypes.FORCE_EXIT_USER,
            logoutDetail: logoutDetail
        };
        window.parent.postMessage(action, window.location.origin);
    });
}
exports.whenUserLogout = whenUserLogout;
